<template>

  <router-view/>
</template>

<script>
export default {
  name: 'App',
  mounted() {
    const setFont = () => {
      const html = document.documentElement;
      const width = html.clientWidth;
      // 基准为 1920px 设计稿，例如 750px 时 1rem = 1px（或其他自定义比例）
      const fontSize = (width / 750) + 'px';
      html.style.fontSize = fontSize;

      // 调试用，记录当前宽度（可删除）
      const viewWidthInput = document.getElementById('viewwidth');
      if (viewWidthInput) viewWidthInput.value = width;
    };

    setFont();
    window.addEventListener('resize', setFont);
    // 在组件销毁前移除监听，避免内存泄漏
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', setFont);
    });
  }
};
</script>